const filterKeywords = (keywords, keyword) => {
  return keywords
    .map((g) => g.filter((k) => k !== keyword))
    .filter((g) => g.length > 0);
};

const filterKeywordsByFunc = (keywords, filterFunc) => {
  return keywords.map((g) => g.filter(filterFunc));
};

const flattenKeywords = (keywords) => {
  return [].concat.apply([], keywords);
};

const addLink = (keywords, keyword1, keyword2) => {
  let group1;
  for (let i = 0; i < keywords.length; i++) {
    if (keywords[i].includes(keyword1)) {
      group1 = i;
      break;
    }
  }
  let ind1 = keywords[group1].indexOf(keyword1);

  let group2;
  for (let i = 0; i < keywords.length; i++) {
    if (keywords[i].includes(keyword2)) {
      group2 = i;
      break;
    }
  }
  let ind2 = keywords[group2].indexOf(keyword2);

  let results;

  if (group1 === group2 && ind2 > ind1) {
    results = keywords.map((k, i) => {
      if (i === group1) {
        return [
          ...keywords[group1].slice(0, ind1),
          keyword1,
          ...keywords[group2].slice(ind2)
        ];
      } else if (i === group2) {
        return keywords[group2].slice(0, ind2);
      } else {
        return k;
      }
    });

    // re-insert orphaned elements of group1
    results = [
      ...results.slice(0, group1 + 1), // group before group1 unaffected
      keywords[group1].slice(ind1 + 1, ind2), //remainder of group1
      ...results.slice(group1 + 1) // groups aftergroup1
    ];
  } else if (group1 === group2 && ind2 < ind1) {
    results = keywords.map((k, i) => {
      if (i === group1) {
        return [keyword1, ...keywords[group1].slice(ind2, ind1)];
      } else {
        return k;
      }
    });

    // re-insert orpahned elements of group1
    results = [
      ...results.slice(0, group1), // group before group1 unaffected
      keywords[group1].slice(0, ind2), // initial part of group1
      results[group1], // modified part of group1
      keywords[group1].slice(ind1 + 1), //remainder of group1
      ...results.slice(group1 + 1) // groups after group1
    ];
  } else {
    results = keywords.map((k, i) => {
      if (i === group1) {
        return [
          ...keywords[group1].slice(0, ind1),
          keyword1,
          ...keywords[group2].slice(ind2)
        ];
      } else if (i === group2) {
        return keywords[group2].slice(0, ind2);
      } else {
        return k;
      }
    });

    // re-insert orphaned elements of group1
    results = [
      ...results.slice(0, group1 + 1), // group before group1 unaffected
      keywords[group1].slice(ind1 + 1), //remainder of group1
      ...results.slice(group1 + 1) // groups aftergroup1
    ];
  }

  // remove any now-empty groups
  results = results.filter((g) => g.length > 0);

  return results;
};

const sortKeywords = (keywords, sortFunc) => {
  /*
    const k = [...keywords];

  // First re-order the groups of keywords
  const cmpFunction = (a, b) => {
    const aVal = Math.min.apply(Math, a.map(scoreFunc));
    const bVal = Math.min.apply(Math, b.map(scoreFunc));
    return aVal - bVal;
  };
  k.sort(cmpFunction);

  // then order within each group
  return k.map((kw) => kw.sort((a, b) => scoreFunc(a) - scoreFunc(b)));
*/

  return [...keywords]
    .map((kw) => kw.sort(sortFunc)) // first order within each group
    .sort((a, b) => sortFunc(a[0], b[0])); // then order groups based on first element of each
};

export {
  addLink,
  filterKeywords,
  filterKeywordsByFunc,
  flattenKeywords,
  sortKeywords
};
